<nav class="navbar navbar-expand-lg bg-white border-bottom border-purple border-opacity-50 px-3 px-lg-4 py-3">
  <div class="container-fluid px-0 d-flex align-items-center gap-3 flex-wrap">
    <button
      v-if="!hide_hamburger"
      class="btn d-flex d-lg-none align-items-center justify-content-center p-0 border-0 bg-transparent"
      @click="$emit('toggle-sidebar')"
      aria-label="Open menu"
    >
      <i class="bi bi-list fs-3 text-dark"></i>
    </button>

    <div class="d-flex align-items-center gap-3 flex-grow-1 min-w-0 overflow-hidden">
      <nav class="ms-4 config-breadcrumbs" aria-label="Breadcrumb">
        <ol class="breadcrumb mb-0 align-items-center flex-nowrap">
          <li
            v-for="(item, index) in breadcrumbItems"
            :key="`${item.label}-${index}`"
            class="breadcrumb-item d-flex align-items-center"
            :class="{ active: item.current }"
            :aria-current="item.current ? 'page' : null"
          >
            <router-link
              v-if="isClickable(item) && !item.current"
              :to="item.to"
              class="text-decoration-none breadcrumb-link"
            >
              {{ item.label }}
            </router-link>
            <span v-else class="breadcrumb-current text-truncate">
              {{ item.label }}
            </span>
          </li>
        </ol>
      </nav>
    </div>

    <div class="ms-auto d-flex align-items-center gap-2 gap-lg-3">
      <div class="input-group d-none d-sm-flex config-search">
        <span class="input-group-text border-0 bg-light">
          <i class="bi bi-search text-secondary"></i>
        </span>
        <input
          type="text"
          class="form-control form-control-sm border-0 bg-light shadow-lg"
          placeholder="Search ...."
        />
      </div>

      <a href="#" class="btn-link text-dark p-2 text-decoration-none">
        <i class="bi bi-bell-fill fs-5 "></i>
      </a>
      <a href="#" class="btn-link text-dark p-2 text-decoration-none">
        <i class="bi bi-question-circle fs-5"></i>
      </a>
      <a href="#" class="text-dark rounded-circle d-flex align-items-center justify-content-center config-avatar-button text-decoration-none">
        <i class="bi bi-person-fill fs-4"></i>
      </a>
    </div>
  </div>
</nav>

<AiconeLogo />